import { RelatedIncidentItem } from "./RelatedIncidentItem";

export * from "./RelatedIncidentItem";
export default RelatedIncidentItem;
